import './index.scss'

// CSS gates hover to fine pointers; touch and reduced-motion show a static label.
export default function RollingText({ children }) {
  return (
    <span className="rolling-text">
      <span className="rolling-text-label">{children}</span>
      <span className="rolling-text-copy" aria-hidden="true">{children}</span>
    </span>
  )
}
